<template>
    <div>
        <!-- 轮播图与通知公告 -->
        <div :class="isMobile?'noticeBoxs':'noticeBoxB'">
            <div :class="isMobile?'noticeShowB':'noticeShow'">
                <swiper-box></swiper-box>
                <notice-box></notice-box>
            </div>
        </div>
        <business-new></business-new>
        <!-- 旧版 使用动态展示 -->
        <!-- <dynamic-box></dynamic-box> -->
        <!-- 新版使用会员单位展示 -->
        <member-unit v-if="!isMobile"></member-unit>
        <member-wx v-if="isMobile"></member-wx>
    </div>
</template>

<script>
    import swiperBox from './components/swiper'
    import noticeBox from './components/notice'
    import dynamicBox from './components/dynamic'
    import businessBox from './components/business'
    import businessNew from './components/businessnew'
    import memberUnit from './components/memberUnit'
    import memberWx from './components/memberWx'
    export default{
        components:{swiperBox,noticeBox,businessBox,businessNew,dynamicBox,memberUnit,memberWx},
        data(){
            return{
                title:'',
            }
        },
        methods:{

        },
        mounted(){
           
        }
    }
</script>

<style scoped>
    .noticeBox{
        width: 100%;
        background-color: #F1F3F6;
        padding: 30px 0;
    }
    .noticeBoxB{
        width: 100%;
        background-color: #F1F3F6;
        padding: 30px 0;
    }
    .noticeShow{
        width: 1400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .noticeShowB{
        width: 100%;
        padding: 10px;
    }
</style>